<template>
  <div class="status-icon">
    <div
      class="status-icon_img status-icon_img_jupiter"
      :class="{'status-icon_img__active': true}"
    >
      <img
        class="status-icon_img_jupiter_inner"
        src="/s-images/icons/logo_jupiter.png"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StatusIconJupiter',
    props: {
      hover: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped lang="less">
.status-icon {
  position: relative;
  width: 33px;
  height: 33px;
  top: 3px;

  .media-xl({
    top: 0;
    width: 42px;
    height: 42px;
  });

  &_img {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    transition: opacity 0.3s ease;
    opacity: 0;
    max-width: 100%;

    &__active {
      opacity: 1;
    }

    &_jupiter {
      background: #181818;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;

      &_inner {
       max-width: 60%;
        opacity: 0.6;
        filter: grayscale(1);
        transition: all 0.3s ease;

      }

      &:hover {
        .status-icon_img_jupiter_inner {
          opacity: 1;
          filter: none;
        }

      }
    }

  }

}
</style>
